import * as React from 'react'
import { styled } from 'next-yak'

import * as behaviours from '../../../behaviours'

import { ColorInput } from '../colorInput/ColorInput'

import { Field } from './Field'
import { FieldStatus } from './FieldStatus'

export type ColorFieldProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'value' | 'prefix'> & {
  context?: string
  description?: string
  error?: React.ReactNode
  help?: React.ReactNode
  /** @default String(Math.random()) */
  label?: React.ReactNode
  success?: React.ReactNode
  onChange: (color: string) => void
  format?: 'wide'
  value: string
}

function ColorFieldComponent({
  className,
  context,
  description,
  error,
  onChange,
  help,
  id = String(Math.random()),
  label,
  success,
  format,
  ...fieldProps
}: ColorFieldProps): React.ReactElement<any> {
  const { classList, status } = behaviours.getStatusClassName(className, error, success)

  return (
    <>
      <ColorFieldWrapper
        className={classList.filter(Boolean).join(' ')}
        context={context}
        htmlFor={id}
        label={label}
        description={description}
        help={help}
        format={format}
      >
        <ColorInput onChange={onChange} status={status} {...fieldProps} />
      </ColorFieldWrapper>
      {(error || success) && <FieldStatus error={error} success={success} />}
    </>
  )
}
export const ColorField = styled(ColorFieldComponent)<ColorFieldProps>``

const ColorFieldWrapper = styled(Field)``
